<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.table && source">
  <div class="banner center" [ngStyle]="{'max-width' : configType == 9 ? '99%' : '1000px'}">
    <div class="row row_header freeze_height">
      <div [ngClass]="configType == 9 ? 'col-1' : 'col-3'">
        <button *ngIf="configType != 0 && !businessId" class="button_icon button_icon_color icon_adjust"
          (click)="onAction(2)" style="float: left; top: 0px !important;">arrow_back</button>
        {{localService.languageContent.table.action}}
      </div>
      <div [ngClass]="configType == 9 ? 'col-11' : 'col-9'">
        {{localService.languageContent.table.title}}
        <div class="icon_action_header">
          <i class="material-icons" *ngIf="hasCtryCode" (click)="onLoad(true)"
            title="{{localService.languageContent.table.refresh}}">refresh</i>
          <i class="material-icons" *ngIf="!hasCtryCode" (click)="openCreateEditPopup('')"
            title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of source.items">
        <div [ngClass]="configType == 9 ? 'col-1' : 'col-3'">
          <i class="material-icons button icon_adjust"
            title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
            (click)="onActiveInactiveStatus(item.key)"
            [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" :
            "toggle_off"}}</i>
          <button style="color:#008CBA;margin-left:10px;" *ngIf="configType == GeneralConfigType.ReceiptType"
            class="button_icon button_icon_color icon_adjust" [disabled]="isDisableReceiptTemplate(item.v4)"
            (click)="onOpenReceiptTemplate(item.v4,item.isSelected)">receipt</button>
          <button style="color:#008CBA;margin-left:10px;" *ngIf="configType == GeneralConfigType.ReceiptType"
            [disabled]="!item.isSelected" class="button_icon button_icon_color icon_adjust"
            (click)="onAction(1,item.v4, item.key)">code</button>
          <i *ngIf="configType == GeneralConfigType.CommunicationTemplateSms || configType == GeneralConfigType.CommunicationTemplateEmail || configType == GeneralConfigType.CommunicationTemplate_WhatsApp"
            class="material-icons button icon_adjust" (click)="onOpenSmsTemplate(item.key, item.v4)">sms</i>
          <button style="color:#008CBA;margin-left:10px;" *ngIf="configType == 0 && !hasCtryCode"
            class="button_icon button_icon_color " (click)="oNavigate(ctryCodeSub,false,item.v4)">account_tree</button>
          <button style="color:#008CBA;margin-left:10px;" *ngIf="configType == 0" class="button_icon button_icon_color "
            (click)="oNavigate(ctryCodeSub,true,item.v4)">place</button>
        </div>
        <div [ngClass]="configType == 9 ? 'col-11' : 'col-9'">
          <div class="single_line" [ngClass]="businessId ? '' : 'button'"
            (click)="openCreateEditPopup(hasCtryCode ? item.v1 : item.key,item.v5)">
            <span class="en">({{item.v4}})&nbsp;</span>
            {{item.v3}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>